import { render, staticRenderFns } from "./SelectDestinationCampaignMergeDialog.vue?vue&type=template&id=c6dc1830&scoped=true&"
import script from "./SelectDestinationCampaignMergeDialog.vue?vue&type=script&lang=ts&"
export * from "./SelectDestinationCampaignMergeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SelectDestinationCampaignMergeDialog.vue?vue&type=style&index=0&id=c6dc1830&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dc1830",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VCard,VCardText,VDialog,VForm,VIcon})
